/* eslint-disable indent */
/*
All functions for communication via JSON
*/

import axios from 'axios';
import loginTemplate from './data/TemplateLoginDTO.json';
import passwordTemplate from './data/TemplateUserDTO.json';
import deleteTemplate from './data/TemplateDirectoryDTODelete.json';
import propertiesTemplate from './data/TemplatePropertiesDTO.json';
import jobPropertiesTemplate from './data/TemplateJobPropertiesDTO.json';
import propertiesTemplateOwn from './data/TemplatePropertiesDTOOwn.json'; // due to js caching problem
import directoryTemplate from './data/TemplateDirectoryDTO.json';
import directoryUserTemplate from './data/TemplateDirectoryDTOTest.json'; // successfully tested and being used
import statisticDirectoryTemplate from './data/TemplateStatisticDirectoryDTO.json';
import statisticRecordstructureTemplate from './data/TemplateRecordstructureDirectoryDTO.json';
import statisticRecordstructureEmptyTemplate from './data/TemplateRecordstructureDirectoryEmptyDTO.json';
import propertiesRecordstructureTemplate from './data/TemplateRecordstructurePropertiesDTO.json';
import codingValueassociationToKMAZ from './data/TemplateValueassociationPropertiesCodingValueassociationToKMAZ.json';
import dependencyDeleteTemplate from './data/TemplateDependencyDeleteDTO.json';
import propertiesEditTemplate from './data/TemplatePropertiesEditDTO.json';
import dataStockPropertiesTemplate from './data/TemplateDataStockProperties.json';
import rulePropertiesTemplate from './data/TemplateRuleProperties.json';
import forDTOTemplate from './data/TemplateForDTO.json';
import forDTOTemplatevariableinit from './data/TemplateForDTOvariableinit.json';
import recordStructureDirectoryFilledTemplate from './data/TemplateRecordstructureDirectoryFilledDTO.json';
import recordStructureDirectoryFilledOSTemplate from './data/TemplateRecordstructureDirectoryFilledOSDTO.json';
import ordercriterionInsertTemplate from './data/TemplateOrdercriterionInsert.json';
import debugTemplate from './data/TemplateDebugDTO.json';
import JsonHelper from '../utils/statisticsUtils';
import statisticDirectoryAdminTemplate from './data/TemplateDirectoryAdminDTO.json';

const statisticLinks = JSON.stringify(dataStockPropertiesTemplate.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.links[0]);
// const dataStockProperties = JSON.stringify(dataStockPropertiesTemplate);
// const { ENVIRONMENT } = window;
const restPath = window.REST_PATH;
const { DEBUG_FLAG } = window;
const log = function consoleLog(...args) {
  // eslint-disable-next-line no-console
  if (DEBUG_FLAG) console.log(...args);
};

export default class MessageService {

  // /variableValueBuild/variableinit  (neues Merkmal mit Owner initialisieren)
  async postVariableValueBuildVariableinit() {
    let template = JSON.stringify(forDTOTemplatevariableinit);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'variableValueBuild/variableinit',
      'postVariableValueBuildVariableinit');
    // return value needed
    return res.data;
  }

  getCreatehelperCreatetextobject = async () => {
    const newPathUpload = `${restPath}createhelper/createtextobject`;
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`getCreatehelperCreatetextobject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getCreatehelperCreatetextobject', res1);
    return res1;
  }

  // /variableValueBuild/ruleinit  (neue Regel mit Owner initialisieren)
  async postVariableValueBuildRuleinit() {
    let template = JSON.stringify(forDTOTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'variableValueBuild/ruleinit',
      'postVariableValueBuildRuleinit');
    // return value needed
    return res.data;
  }

  // variableValueBuild/createBaseVariable (leeres Basismerkmal erzeugen)
  getVariableValueBuildCreateBaseVariable = async () => {
    // async getVariableValueBuildCreateBaseVariable() {
    log('start: getVariableValueBuildCreateBaseVariable');
    let template = JSON.stringify(forDTOTemplate);
      template = template.replace(
          /\$SESSIONID/,
          sessionStorage.getItem('uuid'),
      );
    const newPathUpload = `${restPath}variableValueBuild/createBaseVariable`;
    const res1 = await axios
      .post(
        newPathUpload,
        template,
          { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((response) => {
        // handle error
        let errortext = response.data.contents[
            'genesis.container.content.GenesisNotificationContent'
            ].notifications[0].message;
        if (errortext) log('This is the error to be returned: ', errortext);
        else log('This is the error to be returned: ', response);
        // return [`getVariableValueBuildCreateBaseVariable: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getVariableValueBuildCreateBaseVariable', res1);
    return res1?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel;
  }

  // /variableValueBuild/createFilterobject (leeres Filterobjekt erzeugen)
  getVariableValueBuildCreateFilterobject = async () => {
    // async getVariableValueBuildCreateFilterobject() {
    log('start: getVariableValueBuildCreateFilterobject');
    const newPathUpload = `${restPath}variableValueBuild/createFilterobject`;
      let template = JSON.stringify(forDTOTemplate);
      template = template.replace(
          /\$SESSIONID/,
          sessionStorage.getItem('uuid'),
      );
    const res1 = await axios
      .post(
        newPathUpload,
          template,
          { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((response) => {
        // handle error
          let errortext = response.data.contents[
              'genesis.container.content.GenesisNotificationContent'
              ].notifications[0].message;
          if (errortext) log('This is the error to be returned: ', errortext);
          else log('This is the error to be returned: ', response);
        // return [`getVariableValueBuildCreateFilterobject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getVariableValueBuildCreateFilterobject', res1);
    return res1?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel;
  }

  // /variableValueBuild/insert (Speichern der Regel und des ErgebnisMerkmals)
  async postVariableValueBuildInsert(template) {
    log('FILTER#5.1', template);
    // let template = JSON.stringify(directoryTemplate);
    // send promise

    log('postVariableValueBuildInsert template', template);
    log('postVariableValueBuildInsert SAVE DISABLED!');
    const res = await this.postMessage(template,
      'variableValueBuild/insert',
      'postVariableValueBuildInsert');
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data;
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      // window.location.replace("./login");

    } else {
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
      ];
    }
  }

  async postAdminList() {
    let template = JSON.stringify(statisticDirectoryAdminTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'user/groupAdminList',
      'postAdminList');
    // return value needed
    return res.data;
  }


  async postFolderInit() {
    let template = JSON.stringify(directoryTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'folder/init',
      'postFolderInit');
    // return value needed
    return res.data;
  }

  async postFolderAssociationInitInit() {
    let template = JSON.stringify(directoryTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );

    // send promise
    const res = await this.postMessage(template,
      'folderAssociation/init',
      'postFolderAssociationInitInit');
    // return value needed
    return res.data;
  }

  async postFolderProperties(id) {
    let template = JSON.stringify(rulePropertiesTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    template = template.replace(
      /\$ID/,
      id,
    );
    template = template.replace(
      /\$OBJECT/,
      '190',
    );
    template = template.replace(
      /\$OBJECTTYPE/,
      'FOLDER',
    );
    // send promise
    const res = await this.postMessage(template,
      'folder/properties',
      'postFolderProperties');
    // return value needed
    return res.data;
  }

  async postFolderAssociationProperties(id) {
    let template = JSON.stringify(rulePropertiesTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    template = template.replace(
      /\$ID/,
      id,
    );
    template = template.replace(
      /\$OBJECT/,
      '191',
    );
    template = template.replace(
      /\$OBJECTTYPE/,
      'FOLDER_STRUCTURE_ASSOCIATION',
    );
    // send promise
    const res = await this.postMessage(template,
      'folderAssociation/properties',
      'postFolderAssociationProperties');
    // return value needed
    return res.data;
  }

  async postFolderInsert(folderName, folderInit, rightArea) {
    console.log("postFolderInsert", folderName, folderInit)
    const copy = {...folderInit}
    copy.contents['genesis.container.content.GenesisTMContent'].transfermodel.name = folderName
    copy.contents['genesis.container.content.GenesisTMContent'].transfermodel.ownerInfo.rightArea = rightArea
    copy.contents['genesis.container.content.GenesisTMContent'].uuid = sessionStorage.getItem('uuid')
    const response = await this.postMessage(copy, 'folder/insert', 'postFolderInsert')
    return response
  }

  async postFolderAssociationInsert(folderInit, ownerInfo) {
    const copy = {...folderInit}
    copy.contents['genesis.container.content.GenesisTMContent'].transfermodel.ownerInfo = ownerInfo
    copy.contents['genesis.container.content.GenesisTMContent'].uuid = sessionStorage.getItem('uuid')
    const response = await this.postMessage(folderInit, 'folderAssociation/insert', 'postFolderAssociationInsert')
    return response
  }

  async postFolderUpdate(newFolderName, id, folderInit) {
    const tmpResult = await this.postFolderProperties(id);
    const tmp = {...tmpResult.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0]}
    tmp.name = newFolderName
    folderInit.contents['genesis.container.content.GenesisTMContent'].transfermodel = tmp;
    const response = await this.postMessage(folderInit, 'folder/update', 'postFolderUpdate')
    return response
  }

  async postFolderAssociationUpdate(folderIdent, folderName, structureIdent, structureName, id, init) {
    const tmpResult = await this.postFolderAssociationProperties(id);
    const tmp = {...tmpResult.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0]}
    tmp.folderIdent = folderIdent
    tmp.folderReference = null
    tmp.folderName = folderName
    tmp.structureIdent = structureIdent
    tmp.structureReference = null
    init.contents['genesis.container.content.GenesisTMContent'].transfermodel = tmp;
    const response = await this.postMessage(init, 'folderAssociation/update', 'postFolderAssociationUpdate')
    return response
  }

  async postFolderDelete(id) {
    const tmpResult = await this.postFolderProperties(id);
    const tmp = {...tmpResult.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0]}
    const template = JsonHelper.deepCopy(deleteTemplate);
    template.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel = tmp

    template.contents[
      'genesis.container.content.GenesisTMContent'
    ].uuid = sessionStorage.getItem('uuid');

    const response = await this.postMessage(template, 'folder/delete', 'postFolderDelete')

    if(response?.data?.contents?.['genesis.container.content.GenesisNotificationContent']) {
      const notification = response.data.contents.['genesis.container.content.GenesisNotificationContent'].notifications[0]
      if(notification.number === 18130) {
        return {
          message: notification.message,
          severity: 'error',
          content: response,
          number: notification.number,
        }
      }
        return {message: notification.message, severity: 'error', number: notification.number}
    }
    
    return {content: response.data.contents['genesis.container.content.GenesisTMContent']}
  }


  async postFolderAssociationDelete(id) {
    const tmpResult = await this.postFolderAssociationProperties(id);
    const tmp = {...tmpResult.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0]}
    const template = JsonHelper.deepCopy(deleteTemplate);
    template.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel = tmp

    template.contents[
      'genesis.container.content.GenesisTMContent'
    ].uuid = sessionStorage.getItem('uuid');

    const response = await this.postMessage(template, 'folderAssociation/delete', 'postFolderAssociationDelete')
    return response
  }

  async postStructureInit() {
    let template = JSON.stringify(directoryTemplate);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'structure/init',
      'postStructureInit');
    // return value needed
    return res?.data;
  }

  async postRetrievalJobInit(structureDTO) {
    const tmp = {...directoryTemplate}
    tmp.contents["genesis.container.content.GenesisTMContent"].transfermodel = structureDTO;
    let template = JSON.stringify(tmp);
    template = template.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(template,
      'retrievaljob/init',
      'postRetrievalJobInit');
    // return value needed
    return res.data;
  }


  // Tabellenabruf
  async postValueRetrievalStart(obj) {
    const {
      link, tree, loadedTable, notShowSecretValues, zusatzfilter,
    } = obj;
    log('postValueRetrievalStart', link, tree, loadedTable, notShowSecretValues);
    let returnMessage;
    const showSecretValues = !notShowSecretValues;
    if (loadedTable) {
      returnMessage = loadedTable;
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.defaultTableCheck = ['false'];
    } else {
      returnMessage = await this.postStructureInit();
      if (!returnMessage) {
        return [
          'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.',
          'error',
        ];
      }
      returnMessage = JSON.stringify(returnMessage);
      // eslint-disable-next-line
      returnMessage = returnMessage.replace(/\"DATASET\"/, JSON.stringify("FILE"));
      returnMessage = JSON.parse(returnMessage);
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureAxis = tree.structureAxis;
    }
    if (showSecretValues) {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.showSecretValues = ['true'];
    }
    if (zusatzfilter) {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.zusatzfilter = zusatzfilter;
    }
    // send promise
    const res = await this.postMessage(returnMessage, `${link}/retrieval`, 'postValueRetrievalStart');
    log('### here it comes ###');
    log(res);
    if (!res) {
      return [
        'Es konnten keine Daten geladen werden.',
        'error',
      ];
    }
    if (!res?.data?.contents) {
      return [
        'Es konnten keine Daten geladen werden.',
        'error',
      ];
    }
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return [res.data, returnMessage];
      // return res; //this is the full answer
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      // window.location.replace("./login");
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].number,
      ];
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].number,
    ];
  }

  async postValueRetrievalKeys(link, tree, loadedTable, notShowSecretValues) {
    log('postValueRetrievalKeys', link, tree, loadedTable, notShowSecretValues);
    let returnMessage;
    const showSecretValues = !notShowSecretValues;
    if (loadedTable) {
      returnMessage = loadedTable;
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.defaultTableCheck = ['false'];
    } else {
      returnMessage = await this.postStructureInit();
      returnMessage = JSON.stringify(returnMessage);
      // eslint-disable-next-line
      // returnMessage = returnMessage.replace(/\"DATASET\"/, JSON.stringify("FILE"));
      returnMessage = JSON.parse(returnMessage);
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.footnote = tree.footnote;
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.structureAxis = tree.structureAxis;
    }
    log('SECRET#', showSecretValues);
    if (showSecretValues) {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.showSecretValues = ['true'];
    }
    log('OBJECT', returnMessage);
    // send promise
    const res = await this.postMessage(returnMessage, `${link}/retrieval`, 'postValueRetrievalStart');
    log('### here it comes ###');
    log(res);
    if (!res) {
      return [
        'Es konnten keine Daten geladen werden.',
        'error',
      ];
    }
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return [res.data, returnMessage];
      // return res; //this is the full answer
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      // window.location.replace("./login");
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].number,
      ];
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].number,
    ];
  }

  async postValueRetrievalHtml(link, returnMessage) {
    log('postValueRetrievalHtml', link, returnMessage);
    // returnMessage is the return from postValueRetrievalStart
    // send promise

    const res = await this.postMessage(returnMessage, `${link}/htmltable`, 'postValueRetrievalHtml');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('STEP#1');
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res; // this is the full answer
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      log('STEP#3');
      log('Java-Error',
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message);
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
      ];
      // window.location.replace("./login");
    } else {
      log('STEP#4');
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
      ];
    }
  }

  async postPropertiesEdit(object, link, type, name, text, longtext, tabsEntrys) {
    log('postPropertiesEdit');
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    // returnMessage = JSON.stringify(propertiesEditTemplate);
    const returnMessage = propertiesEditTemplate;

    log('postPropertiesEdit1', tabsEntrys);
    returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys = tabsEntrys;
    log('postPropertiesEdit2', returnMessage);
    returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.object[0] = `${object}`;
    // returnMessage = JSON.stringify(propertiesEditTemplate);
    returnMessage.contents['genesis.container.content.GenesisTMContent'].uuid = sessionStorage.getItem('uuid');
    let german = 0;
    if (returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].shortDescription.langText[1].sprachKennzeichen === 'de') german = 1;
    returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].shortDescription.langText[german].text = text;

    log('postPropertiesEdit', returnMessage);

    // returnMessage = JSON.parse(returnMessage);

    log('postPropertiesEdit', returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys);
    // send promise
    const res = await this.postMessage(returnMessage, `${link}/update`, 'postPropertiesEdit');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      // window.location.replace("./login");

    } else {
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
      ];
    }
  }

  async postDependencyDelete(object, type, transfermodel, returnMessageInput, selection, onlyDelete) {
    log('postDependencyDelete', returnMessageInput);
    let returnMessage = returnMessageInput;
    if (!selection) selection = '134';
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    if (!returnMessage) {
      returnMessage = JSON.stringify(dependencyDeleteTemplate);
      returnMessage = returnMessage.replace(
        /\$SESSIONID/,
        sessionStorage.getItem('uuid'),
      );
      returnMessage = returnMessage.replace(
        /\$OBJECT/,
        object,
      );
      returnMessage = returnMessage.replace(
        /\$SELEKTION/,
        selection,
      );
      returnMessage = JSON.parse(returnMessage);
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel = transfermodel;
    }
    log('postDependencyDelete2');
    log('### before ###', returnMessage);
    log(`XXXX ${JSON.stringify(returnMessage)}`);
    log('### before ###', type);
    log('postDependencyDelete3');
    // send promise
    const deleteFunction = `${type}/dependencydelete`;
    if (onlyDelete) deleteFunction = `${type}/delete`;
    const res = await this.postMessage(returnMessage, deleteFunction, 'postDependencyDelete');
    log('### here it comes ###');
    log(res);

    try {
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      // return value needed
      if (
        typeof res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
        ] === 'undefined'
      ) {
        log('success: no error in answer');
        res.data.contents[
          'genesis.container.content.GenesisTMContent'
        ].menuRoot = null;
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      }
      if (
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message
        === 'javax.ejb.EJBTransactionRolledbackException'
      ) {
        // window.location.replace("./login");

      } else {
        let handling = 'error';
        if (res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].handling === 'INFORMATION' ||
        res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].number === 16719) {
          handling = 'info';
        }
        if(res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].number === 16717 ||
        res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].number === 104 ||
        res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].number === 112)
          handling = 'error';
        return [
          res.data.contents[
            'genesis.container.content.GenesisNotificationContent'
          ].notifications[0].message,
          handling,
          res.data,
          res.data.contents[
            'genesis.container.content.GenesisNotificationContent'
          ].notifications[0].number,
        ];
      }
    } catch (e) {
      const handling = 'error';
      const text = 'Der Datensatz konnte nicht gelöscht werden';
      return [
        text,
        handling,
      ];
    }
  }

  async postRecordStructureDirectory1(objtype, type, object, readingDirection, entries,
    maxRowsPerPage) {
    log('postRecordStructureDirectory1:', objtype, type, object, readingDirection, entries, maxRowsPerPage);
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    log('maxRowsPerPage', maxRowsPerPage);
    const tmpReturnMessage = JSON.stringify(statisticRecordstructureEmptyTemplate);
    let returnMessage = JSON.parse(tmpReturnMessage);
    if (readingDirection) { // check if reading direction is specified
      if (entries === null) { // no starting point
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.entrys = [];
      } else { // add starting point if an entry is passed
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.entrys[0] = entries; // starting point to be inserted in the message
      }
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.viewSpecification.readingDirection = readingDirection;
      if (objtype === 'VALUE') {
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.viewSpecification.sortCriterion = 'Fachschlüssel';
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.viewSpecification.searchCriterion = 'Fachschlüssel';
      }
      if (objtype === 'FILE_DESCRIPTION') {
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.viewSpecification.sortCriterion = 'Land';
        returnMessage.contents[
          'genesis.container.content.GenesisTMContent'
        ].transfermodel.viewSpecification.searchCriterion = 'Land';
      }
    }
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(
      /\$MAXROWS/g,
      maxRowsPerPage,
    );
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // Search String / ID
    returnMessage = returnMessage.replace(
      /\$OBJECT1/g,
      object,
    );
    returnMessage = returnMessage.replace(
      /\$OBJECTTYPE/g,
      objtype,
    );

    // send promise
    let res = await this.postMessage(returnMessage,
      `${type}/directory`,
      'postRecordStructureDirectory1');
    log(res);
    let resTmp = JSON.stringify(res);
    if (type === 'variable') { // do not show -1 as position number
      // "valueCount": -1
      // eslint-disable-next-line
      resTmp = resTmp.replace(/\"valueCount\":-1,/g,
        '"valueCount":null,');
      res = JSON.parse(resTmp);
    }

    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      // window.location.replace("./login");

    } else {
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications[0].message,
        'error',
      ];
    }
  }

  getDataStockDelete = async (id) => {
    // async getDataStockDelete(id) {
    log('start: getDataStockDelete');
    id = id + '.csv';
    const newPathUpload = `${restPath}file/deletetimeslicewname?uuid=${sessionStorage.getItem('uuid')}&importfilename=${id}`;
    log('newPathUpload', newPathUpload);
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`Regionalzeitscheibe löschen: ${errortext}`, 'error'];
        return ['Beim Löschen der Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });

    this.checkForLogout(res1?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);

    return res1;
  }

  getUploadDelete = async (filename) => {
    // async getDataStockDelete(id) {
    log('start: getDataStockDelete');
    const newPathUpload = `${restPath}file/deletetimeslicewname?uuid=${sessionStorage.getItem('uuid')}&importfilename=${filename}`;
    log('newPathUpload', newPathUpload);
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`Regionalzeitscheibe löschen: ${errortext}`, 'error'];
        return ['Beim Löschen der Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });

      this.checkForLogout(res1?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);

    return res1;
  }

  async postVariableDirectory(path, type, right, objectNumber, objectTyp,
    typeStringInput, onlyTable, linksArray, numberInput, selection, page, maxRowsPerPage) {
    const number = numberInput || 10000;
    log('postVariableDirectory: KEY#', path, type, right, objectNumber, objectTyp,
      typeStringInput, onlyTable);
    let returnMessage;
    let typeString = typeStringInput;
    if (onlyTable) {
      returnMessage = JSON.stringify(recordStructureDirectoryFilledOSTemplate);
      typeString = 'Standard';
    } else {
      returnMessage = JSON.stringify(recordStructureDirectoryFilledTemplate);
    }
    if (linksArray) {
      returnMessage = JSON.parse(returnMessage);
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.links = linksArray;
      returnMessage = JSON.stringify(returnMessage);
    }
    if (selection) {
      returnMessage = JSON.parse(returnMessage);
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.selection = `*${selection}*`;
      returnMessage = JSON.stringify(returnMessage);
    }
    if (!typeString) typeString = 'alle';
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );

    if(page && maxRowsPerPage) {
        returnMessage = JSON.parse(returnMessage);
        returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.page = page;
        returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.maxRowsPerPage = maxRowsPerPage;
        returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.scrolling = false;
        returnMessage = JSON.stringify(returnMessage);
    } else {
        returnMessage = returnMessage.replace(/\$NUMBER/, number);
    }

    returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    returnMessage = returnMessage.replace(/\$RIGHT/, right);
    returnMessage = returnMessage.replace(/\$OBJECTTYPE/, objectTyp);
    returnMessage = returnMessage.replace(/\$OBJECTTYP/, objectTyp);
    returnMessage = returnMessage.replace(/\$OBJECTNUMBER/, objectNumber);
    returnMessage = returnMessage.replace(/\$TYPESTRING/, typeString);
    //returnMessage = returnMessage.replace(/\$NUMBER/, number);

    log('### before ###', type);
    // send promise
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'postDataStockProperties');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }

    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].number,
    ];
  }

  async postRuleProperties(path, type, name, id, obj) {
    log('postRuleProperties:', path, type, name);
    // returnMessage = returnMessage.replace(/\$NAME/, name);
    let strObject, strObjectType, kriterium;
    if (!obj) {
      strObject = '34';
      strObjectType = 'RULE';
    } else {
      strObject = obj.object;
      strObjectType = obj.objectType;
      kriterium = obj?.kriterium;
    }
    let returnMessage = JsonHelper.deepCopy(rulePropertiesTemplate);
    if (kriterium) {
        returnMessage.contents.[
        'genesis.container.content.GenesisTMContent'
      ].parameter.hashMap.kriterium = kriterium;
    }
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(/\$ID/, id);
    returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    returnMessage = returnMessage.replace(/\$OBJECT/, strObject);
    returnMessage = returnMessage.replace(/\$OBJECTTYPE/, strObjectType);
    log('### before ###', type);
    // send promise
    log('repeat returnMessage', returnMessage);
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'postRuleProperties');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  // für Eigenschaften W-MM
  async postVariableProperties(path, type, name, id) {
    log('postVariableProperties:', path, type, name, id);
    const { searchCriterion } = statisticRecordstructureTemplate.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification;
    let returnMessage = JSON.stringify(statisticRecordstructureTemplate);
    let ttype = 'TARGET_VARIABLE';
    if (type === 'structure') ttype = type.toUpperCase();
    log('#DEBUG', returnMessage);
    returnMessage = returnMessage.replace(/\$ID/, id);
    returnMessage = returnMessage.replace(/\$OBJECTTYPE/, type.toUpperCase());
    returnMessage = returnMessage.replace(/\$OBJECTTYPE/, type.toUpperCase());
    returnMessage = returnMessage.replace(/\$TYPE/, ttype);
    returnMessage = returnMessage.replace(/\$NAME/, name);
    returnMessage = returnMessage.replace(/\$SORTCRITERION/, searchCriterion);
    returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    log('#DEBUG#AA', returnMessage);
    log('### before ###', type);
    // send promise
    log('repeat returnMessage', returnMessage);
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'propertiesFormAssociatedVariable');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postDataStockProperties(selectedStatistics, path, type, isLandStringIput, zusatzfilter) {
    log('postDataStockProperties hier:', selectedStatistics, path, type, isLandStringIput);
    let isLandString = isLandStringIput;
    let returnMessage = JSON.stringify(dataStockPropertiesTemplate);
    let name = '';
    let filledRepeat = '';
    const arrRepeat = [];
    if (!isLandString) isLandString = 'false';
    if (selectedStatistics !== '') {
      name = `${selectedStatistics[0].name}`;
      for (let i = 0; i < selectedStatistics.length; i += 1) {
        filledRepeat = statisticLinks.replace(/\$NAME/, selectedStatistics[i].name);
        arrRepeat[i] = JSON.parse(filledRepeat);
      }
      // log("testing5", arrRepeat)
      const sendJson = JsonHelper.deepCopy(dataStockPropertiesTemplate);
      sendJson.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.land = [isLandString];
      if (zusatzfilter) {
        sendJson.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.zusatzfilter = [zusatzfilter];
      } else {
        sendJson.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.zusatzfilter = ['UNDEF'];
      }
      sendJson.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.links = arrRepeat;
      returnMessage = JSON.stringify(sendJson);
      returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    } else {
      returnMessage = returnMessage.replace(
        /\$SESSIONID/,
        sessionStorage.getItem('uuid'),
      );
      returnMessage = returnMessage.replace(/\$NAME/, name);
      returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    }

    log('### before ###', type);
    // send promise
    log('repeat returnMessage', returnMessage);
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'postDataStockProperties');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postOrdercriterionInsert(name, statisticName, topicType) {
    // log('postOrdercriterionInsert:', name, statisticName);
    let returnMessage = JSON.stringify(ordercriterionInsertTemplate);
    const type = 'ordercriterion';
    const path = 'insert';
    returnMessage = returnMessage.replace(/\$STATISTICNAME/, statisticName);
    returnMessage = returnMessage.replace(/\$TOPICTYPE/, topicType);
    returnMessage = returnMessage.replace(/\$NAME/, name);
    returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    returnMessage = JSON.parse(returnMessage).data;
    log('### before ###', type);
    // send promise
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'postDataStockProperties');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postDataStockProperties1(selectedStatistics, path, type, isLand, links, fast) {
    log('postDataStockProperties1:', selectedStatistics, path, type, isLand, links, fast);
    let isLandString = isLand + '';
    if (!isLand) isLandString = 'false';
    let returnMessage = dataStockPropertiesTemplate;
    returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.land = [isLandString];
    if (fast) {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.fast = ['true'];
    }
    returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.rightallocation = ['true'];
    const name = selectedStatistics; // war: "";
    if (links) {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.links = links;
      returnMessage = JSON.stringify(returnMessage);
    } else {
      returnMessage.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.links[0].name = name;
      returnMessage = JSON.stringify(returnMessage);
      // returnMessage = returnMessage.replace(/\$NAME/, name);
      // const returnMessage1 = returnMessage.replace(/\$NAME/, name);
      log('STAT#3', name);
      log('STAT#4', returnMessage);
    }
    returnMessage = returnMessage.replace(/\$SESSIONID/, sessionStorage.getItem('uuid'));
    log('### before ###', type);
    // send promise
    const res = await this.postMessage(returnMessage, `${type}/${path}`, 'postDataStockProperties1');
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postRecordStructureUpdate1(returnMessage, type) {
    log('postRecordStructureUpdate:', returnMessage, type);
    // log("postRecordStructureUpdate1")
    // ### initiating record structure directory on opening statistic ###

    // prepare Message
    // nothing

    log('### before ###', type);
    // send promise
    const res = await this.postMessage(returnMessage, 'filedescriptor/rightupdate', 'rightupdate');
    log('### rightupdate: here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postRecordStructureUpdate(returnMessage, type, linkinput) {
    log('postRecordStructureUpdate:', returnMessage, type);
    // log("postRecordStructureUpdate")
    // ### initiating record structure directory on opening statistic ###

    // prepare Message
    // nothing
    const link = (linkinput) || 'update';
    log('### before ###', type);
    // send promise
    // hier geht auch delete
    const res = await this.postMessage(returnMessage, `${type}/${link}`, 'postRecordStructureUpdate');
    log('### postRecordStructureUpdate: here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      if (link === 'retrievalCache') {
        return res.data;
      } else {
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      }
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postRecordStructureDelete(confirmation, type) {
    log('MSG#', confirmation);
    if (!type) type = 'ordercriterion';
    const returnMessage = JsonHelper.deepCopy(confirmation);
    const pathLink = 'delete';
    // const type = 'ordercriterion';
    log('### before ###', `${type}/${pathLink}`);
    const res = await this.postMessage(returnMessage, `${type}/${pathLink}`, 'postRecordStructureProperties');
    log('### here it comes ###');
    log('###Result', res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;

      /*
      if (returnShort) {
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      }
      */
      return res.data;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
      res,
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].number,
    ];
  }

  async postRecordStructureProperties(selection, object, type, returnShort, emptyArg,
    insertMessage, link) {
    log('postRecordStructureProperties:', selection, object, type, returnShort, emptyArg, insertMessage, link);
    // log("postRecordStructureProperties")
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    let returnMessage;
    let pathLink = 'properties';
    log('pathLink1', pathLink);
    if (link) pathLink = link;
    log('pathLink2', pathLink);
    if (insertMessage) {
      returnMessage = JSON.stringify(insertMessage);
    } else {
      returnMessage = JSON.stringify(propertiesRecordstructureTemplate);
      returnMessage = returnMessage.replace(
        /\$SESSIONID/,
        sessionStorage.getItem('uuid'),
      );
      returnMessage = returnMessage.replace(
        /\$SELEKTION/,
        selection,
      );
      returnMessage = returnMessage.replace(
        /\$OBJECT/,
        object,
      );
    }
    log('### before ###', `${type}/${pathLink}`);
    // send promise
    const res = await this.postMessage(returnMessage, `${type}/${pathLink}`, 'postRecordStructureProperties');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;

      if (returnShort) {
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
      }
      return res.data;
    }
    const { notifications } = res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
    ];
    log('NOTE#', notifications);
    if (
      notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      return [
        notifications[0].message,
        'error',
        res,
        notifications[0].number,
      ];
      // window.location.replace(`${process.env.PUBLIC_URL}/login`);
    } else if (notifications[0].number === 8083) {
      console.log('NODE#4')
      return [
        'Ein Objekt mit diesem Namen existiert bereits.',
        'error',
        res,
        notifications[0].number,
      ]
    } else {
      return [
        notifications[0].message,
        'error',
        res,
        notifications[0].number,
      ];
    }
  }

  async postFreeInput(link, fnk, obj) {
    let { tableStructure, doReturn } = obj;
    log('postTableExport:', obj, tableStructure);
    const res = await this.postMessage(tableStructure, `${link}/${fnk}`, 'postFreeInput');
    if (doReturn) {
      return [
        res.data.contents[
          'genesis.container.content.GenesisNotificationContent'
        ].notifications,
        'error',
        res.data,
      ];
    }
  }

  async postCodingValueassociationToKMAZ(cvas) {
    const template = codingValueassociationToKMAZ;

    template.contents['genesis.container.content.GenesisTMContent'].transfermodel = cvas;

    template.contents['genesis.container.content.GenesisTMContent'].uuid = sessionStorage.getItem('uuid')

    const pathLink = 'properties';
    const type = 'valueassociation';

    log('### before ###', `${type}/${pathLink}`);
    // send promise
    const res = await this.postMessage(template, `${type}/${pathLink}`, 'postCodingValueassociationToKMAZ');
    log('postCodingValueassociationToKMAZ', res);

    return res?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys || [];
  }

  async postTableExport(link, tableStructure) {
    log('postTableExport:', link, tableStructure);
    // log("postRecordStructureProperties")
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    log('### before ###', `${link}/export`);
    // send promise
    const res = await this.postMessage(tableStructure, `${link}/export`, 'postTableExport');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data;
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications,
      'error',
      res.data,
    ];
  }

  async postTableExportDownload(link, tableStructure) {
    log('postTableExport:', link, tableStructure);
    // log("postRecordStructureProperties")
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    log('### before ###', `${link}/download`);
    // send promise
    const res = await this.postExportMessage(tableStructure, `${link}/download`, 'postTableExport');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (!res.data.settings && res.data) { return ['success', res.data]; }
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data;
    }
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications,
      'error',
      res.data,
    ];
  }

  async postTableInsert(link, tableStructure, removeOwner) {
    log('postTableInsert:', link, tableStructure, removeOwner);
    // log("postRecordStructureProperties")
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    const pathLink = removeOwner ? 'insertRemoveOwner' : 'insert';

    log('### before ###', `${link}/${pathLink}`);
    // send promise
    const res = await this.postMessage(tableStructure, `${link}/${pathLink}`, 'postTableInsert');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data;
    }
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      return res;
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications,
      'error',
      res.data,
    ];
  }

  async postTableUpdate(link, tableStructureInput) {
    const tableStructure = tableStructureInput;
    tableStructure.defaultContent = 'genesis.container.content.GenesisTMContent';
    log('postTableUpdate:', link, tableStructure);
    // log("postRecordStructureProperties")
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    log('### before ###', `${link}/update`);
    // send promise
    const res = await this.postMessage(tableStructure, `${link}/update`, 'postTableUpdate');
    log('### here it comes ###');
    log(res);
    // return value needed
    if (res.status === 204) {
      return 'success';
    }
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      return res.data;
    }
    /* if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      window.location.replace(`${process.env.PUBLIC_URL}/login`);
    } else { */
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications,
      'error',
    ];
    /* } */
  }

  async postRecordStructureDirectoryWithPagination(id, level, type, ttype, objtype, emptyArg, id2Input, page=1, maxRowsPerPage=1000, sortCriterion="Name", sortDirection="ASC", filter="", searchCriterion="") {
    log("postRecordStructureDirectoryWithPagination: ",id, level, type, ttype, objtype, emptyArg, id2Input, page, maxRowsPerPage, sortCriterion, sortDirection)
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    let strDirectory = 'directory';
    if (type === 'valueassociation') strDirectory = 'directoryFast';
    let id2 = id2Input;
    if (!id2) id2 = -1;
    log('level#42', type, ttype);

    const template = {...statisticRecordstructureTemplate}

    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.page = page;
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.maxRowsPerPage = maxRowsPerPage;
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.sortDirection = sortDirection;
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.selection = "*" + filter + "*";
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.searchCriterion = searchCriterion;
    let returnMessage = JSON.stringify(template);

    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // Search String / ID
    returnMessage = returnMessage.replace(
      /\$NAME/,
      `${id}`,
    );
    returnMessage = returnMessage.replace(
      /\$TYPE/,
      ttype,
    );
    returnMessage = returnMessage.replace(
      /\$OBJECTTYPE/g,
      objtype,
    );
    returnMessage = returnMessage.replace(
      /\99999999/g,
      id2,
    );
    //
    //const sortcriterion = 'Fachschlüssel';
    // if (type==="datafield") sortcriterion="Position"
    returnMessage = returnMessage.replace(
      /\$SORTCRITERION/g,
      sortCriterion,
    );

    // send promise
    log('loadRecordStructureA');
    let res = await this.postMessage(returnMessage,
      `${type}/${strDirectory}`,
      'postRecordStructureDirectory');
    log('loadRecordStructureB');
    let resTmp = JSON.stringify(res);
    if (type === 'datafield') { // do not show -1 as position number
      // "positionNr": -1
      // eslint-disable-next-line
      resTmp = resTmp.replace(/\"position\":-1,/g,
        '"position":null,');
      res = JSON.parse(resTmp);
    }

    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      if (ttype === 'STATISTIC') {
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      }
      return {
        entries: res?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys || [], 
        validPages: res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.validPages,
        potentialSelectionEntrySize:  res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.potentialSelectionEntrySize
      }
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postRecordStructureDirectory(id, level, type, ttype, objtype, emptyArg, id2Input) {
    log('postRecordStructureDirectory:', id, level, type, ttype, objtype, emptyArg, id2Input);
    // ### initiating record structure directory on opening statistic ###
    // prepare Message
    let strDirectory = 'directory';
    if (type === 'valueassociation') strDirectory = 'directoryFast';
    let id2 = id2Input;
    if (!id2) id2 = -1;
    log('level#42', type, ttype);

    const template = {...statisticRecordstructureTemplate}

    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.page = 1;
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.sortDirection = "ASC";
    template.contents['genesis.container.content.GenesisTMContent'].transfermodel.viewSpecification.maxRowsPerPage = 1000;
    let returnMessage = JSON.stringify(template);

    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // Search String / ID
    returnMessage = returnMessage.replace(
      /\$NAME/,
      `${id}`,
    );
    returnMessage = returnMessage.replace(
      /\$TYPE/,
      ttype,
    );
    returnMessage = returnMessage.replace(
      /\$OBJECTTYPE/g,
      objtype,
    );
    returnMessage = returnMessage.replace(
      /\99999999/g,
      id2,
    );

    returnMessage = returnMessage.replace(
      /\$SORTCRITERION/g,
      "Fachschlüssel",
    );

    // send promise
    log('loadRecordStructureA');
    let res = await this.postMessage(returnMessage,
      `${type}/${strDirectory}`,
      'postRecordStructureDirectory');
    log('loadRecordStructureB');
    let resTmp = JSON.stringify(res);
    if (type === 'datafield') { // do not show -1 as position number
      // "positionNr": -1
      // eslint-disable-next-line
      resTmp = resTmp.replace(/\"position\":-1,/g,
        '"position":null,');
      res = JSON.parse(resTmp);
    }

    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      res.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      if (ttype === 'STATISTIC') {
        return res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
      }
      return res?.data?.contents?.['genesis.container.content.GenesisTMContent']?.transfermodel?.entrys || []
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postStatisticDirectory(returnAll) {
    // initiating statistic directory on loading ImportList
    // prepare Message
    let ret;
    let returnMessage = JSON.stringify(statisticDirectoryTemplate);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    try {
      const res = await this.postMessage(returnMessage,
        'statistic/directory',
        'postStatisticDirectory');
      // return value needed
      if (typeof res.data.contents['genesis.container.content.GenesisNotificationContent'] === 'undefined') {
        log('success: no error in answer');
        log(res.data);
        res.data.contents[
          'genesis.container.content.GenesisTMContent'
        ].menuRoot = null;
        const { entrys } = res.data.contents['genesis.container.content.GenesisTMContent'].transfermodel;
        if (returnAll) {
          ret = entrys;
        } else {
          // remove key-figure-statistics
          const filtered = entrys.filter((item) => item.name < 100000);
          ret = filtered;
        }
        return ret;
      }
      log('############ else i.e. notification');
      return [res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].message, 'info'];
    } catch (err) {
      log('error in postStatisticDirectory', err);
      return [err, 'info'];
    }
  }

  async postProperties(id, sentPath) {
    // initiating Job property display on selecting job in ImportList
    // prepare Message
    let path = sentPath;
    if (!path) path = 'job/properties';
    let returnMessage = jobPropertiesTemplate;
    log(JSON.stringify(returnMessage));
    returnMessage.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.selektion[0] = id;
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(returnMessage,
      path,
      'postJobProperties');
    // return value needed
    if (
      typeof res.data.contents['genesis.container.content.GenesisNotificationContent'] === 'undefined'
    ) {
      log('success: no error in answer');
      log(res.data);
      return res.data;
    }
    log('############ else i.e. notification');
    return [
      res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].message, 'info'];
  }

  async postJobUpdate(returnMessage) {
    // updating Job properties from display in ImportList
    // no need to prepare Message
    // send promise
    const res = await this.postMessage(returnMessage,
      'job/update',
      'postJobUpdate');
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      log(res.data);
      return res.data;
    }
    log('############ else i.e. notification');
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'info',
    ];
  }

  getUserContact = async () => {
    // async getUserContact() {
    // loading Fachadministrator information on loading Login
    // prepare Message
    log('start: getUserContact');
    let returnMessage = JSON.stringify(directoryTemplate);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    log('message sent:');
    log(returnMessage);
    const res = await axios
      .get(
        `${restPath}user/contact`,
        returnMessage,
        { headers: { 'Content-Type': 'application/json' } },
      )
      .then((response) => response.data.contents['genesis.container.content.GenesisTMContent'].transfermodel)
      .catch((response) => {
        // handle error
        const errortext = response;
        log('This is the error to be returned: ', errortext);
        // return [`Fehler beim Laden: ${errortext}`, 'error'];
        return ['Beim Laden der Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    log('############ Success # Answer received:');
    // log(JSON.stringify(res.data));
    // return value needed
    return res;
  }

  async postList(emptyArg, readingDirection, entries, maxRowsPerPage, sortCriterionInput,
    sortDirection, searchCriterionInput, selection, typeString, right) {
    const objtype = 'RIGHT';
    const object = '090';
    const type = 'right';
    let sortCriterion = sortCriterionInput;
    // if (sortCriterionInput === 'Name') sortCriterion = 'Fachschlüssel';
    log('USER#00.2', sortCriterion, readingDirection);

    // loading userlist on loading Useradmin
    // prepare Message
    let searchCriterion = searchCriterionInput;
    searchCriterion = searchCriterion === '' ? 'Nachname' : searchCriterion;
    log('start: postUserList');
    // let returnMessage = recordStructureDirectoryFilledTemplate;
    let returnMessage = statisticRecordstructureEmptyTemplate;
    if (entries === null) {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys = [];
    } else {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys[0] = entries; // starting point to be inserted in the message
    }
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.readingDirection = readingDirection;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortDirection = sortDirection;
    // Fachschlüssel, Kurztext
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortCriterion = sortCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.searchCriterion = searchCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.selection = `${selection}*`;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.maxRowsPerPage = maxRowsPerPage;
    // new
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.typeString = typeString;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.right = right;

    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(
      /\$MAXROWS/g,
      maxRowsPerPage,
    );
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // Search String / ID
    returnMessage = returnMessage.replace(
      /\$OBJECT1/g,
      object,
    );
    returnMessage = returnMessage.replace(
      /\$OBJECTTYPE/g,
      objtype,
    );

    // send promise
    const res = await this.postMessage(returnMessage,
      `${type}/directory`,
      'postRecordStructureDirectory1');
    // let resTmp = JSON.stringify(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      log(
        JSON.stringify(
          res.data.contents['genesis.container.content.GenesisTMContent']
            .transfermodel,
        ),
      );
      return res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel;
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }


  async postPageDirectory(obj) {
    log('ONPAGE#4', obj);
    const {
      objtype, object, type, sortDirection,
      searchCriterion, searchText, scrolling,
      readingDirection, page, entries, maxRowsPerPage,
    } = obj;
    let {
      sortCriterion,
    } = obj;
    // let sortCriterion = sortCriterionInput;
    if (sortCriterion === 'Name') sortCriterion = 'Fachschlüssel';
    log('start: postPageDirectory');
    let returnMessage = statisticRecordstructureEmptyTemplate;
    if (entries === null) {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys = [];
    } else {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys[0] = entries; // starting point to be inserted in the message
    }
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.readingDirection = readingDirection;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortDirection = sortDirection;
    // Fachschlüssel, Kurztext
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortCriterion = sortCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.searchCriterion = searchCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.scrolling = scrolling;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.page = page;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.selection = `${searchText}*`;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.maxRowsPerPage = maxRowsPerPage;
    log('ONPAGE#4.1', returnMessage);
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(
      /\$MAXROWS/g,
      maxRowsPerPage,
    );
    log('ONPAGE#2', returnMessage);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // Search String / ID
    returnMessage = returnMessage.replace(
      /\$OBJECT1/g,
      object,
    );
    returnMessage = returnMessage.replace(
      /\$OBJECTTYPE/g,
      objtype,
    );

    // send promise
    const res = await this.postMessage(returnMessage,
      `${type}/directory`,
      'postRecordStructureDirectory1');
    // let resTmp = JSON.stringify(res);
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      log(
        JSON.stringify(
          res.data.contents['genesis.container.content.GenesisTMContent']
            .transfermodel,
        ),
      );
      return res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel;
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postUserList(functionName, readingDirection, entries, maxRowsPerPage, sortCriterion,
    sortDirection, searchCriterionInput, selection) {
    // loading userlist on loading Useradmin
    // prepare Message
    if (functionName !== 'groupAdminList') functionName = 'directory';
    log('ROLLE# start');
    let searchCriterion = searchCriterionInput;
    searchCriterion = searchCriterion === '' ? 'Nachname' : searchCriterion;
    log('start: postUserList');
    let returnMessage = directoryUserTemplate;
    if (entries === null) {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys = [];
    } else {
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.entrys[0] = entries; // starting point to be inserted in the message
    }
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.readingDirection = readingDirection;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortDirection = sortDirection;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.sortCriterion = sortCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.searchCriterion = searchCriterion;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.selection = `${selection}*`;
    returnMessage.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.viewSpecification.maxRowsPerPage = maxRowsPerPage;
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    // send promise
    const res = await this.postMessage(returnMessage,
      `user/${functionName}`,
      'postUserList');
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      log(
        JSON.stringify(
          res.data.contents['genesis.container.content.GenesisTMContent']
            .transfermodel,
        ),
      );
      return res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel;
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postUserRegistrate(returnMessage) {
    // creating new user on save in Newuser
    // no need to prepare Message
    // send promise
    const res = await this.postMessage(returnMessage,
      'user/registrate',
      'postUserRegistrate');
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      return ['Daten erfolgreich gespeichert!', 'info'];
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    /* if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message
      === 'javax.ejb.EJBTransactionRolledbackException'
    ) {
      window.location.replace(`${process.env.PUBLIC_URL}/login`);
    } else { */

    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
    /* } */
  }

  async postUserUpdate(returnMessageInput, doUpdateOwnData) {
    // saving user data on save in Edituser and Userdata
    // prepare Message
    const returnMessage = returnMessageInput;
    if (doUpdateOwnData) {
      // add argument in JSON for own update
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].parameter.hashMap.supplement = ['1'];
    }
    // send promise
    const res = await this.postMessage(returnMessage,
      'user/update',
      'postUserUpdate');
    // return value needed
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      // window.location.replace("./#/dashboard");
      return ['Daten erfolgreich gespeichert!', 'info'];
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    // return ["Ein Fehler ist beim Speichern aufgetreten.", "error"];
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postUserProperties(
    userName,
    doUpdateOwnData,
  ) {
    // loading user information on loading Edituser
    // prepare Message
    let userData;
    let returnMessage = propertiesTemplate;
    if (doUpdateOwnData === true) {
      returnMessage = propertiesTemplateOwn;
      log('keine Rechte');
      // add argument in JSON for own update
      returnMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].parameter.hashMap.supplement = ['1'];
    } else {
      returnMessage = propertiesTemplate;
    }
    returnMessage = JSON.stringify(returnMessage);
    returnMessage = returnMessage.replace(/\$USERNAME/, userName);
    returnMessage = returnMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    returnMessage = returnMessage.replace(/\$SELEKTION/, userName);
    // send promise
    const res = await this.postMessage(returnMessage,
      'user/properties',
      'postUserProperties');
    // return value needed
    sessionStorage.setItem('tempRes', JSON.stringify(res.data));
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      if (doUpdateOwnData) {
        userData = res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel;
        sessionStorage.setItem('userdata', JSON.stringify(userData));
      } else {
        [userData] = res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.entrys;
        sessionStorage.setItem('userdata', JSON.stringify(userData));
      }
      return userData;
    }
    log('FEHLER');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postPasswordResetFromAdmin() {
    let userData;
    // Requesting new password on checkbox click in Edituser
    // prepare Message
    const returnMessage = sessionStorage.getItem('tempRes');
    log('MessageToPostNewPw New', returnMessage);
    // send promise
    const res = await this.postMessage(returnMessage,
      'user/requirepassword',
      'postPasswordReset',
      true);
    // return value needed
    sessionStorage.setItem('tempRes', JSON.stringify(res.data));
    log('resDataNew', res.data);
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      [userData] = res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.entrys;
      log(JSON.stringify(userData));
      return userData;
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0],
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  async postPasswordReset() {
    // Requesting new password on checkbox click in Edituser
    // prepare Message
    let userData;
    const returnMessage = sessionStorage.getItem('tempRes');
    log('MessageToGetNewPw Old', returnMessage);

    // send promise
    const res = await this.postMessage(returnMessage,
      'user/requirepassword',
      'postPasswordReset',
      true);
    // return value needed
    sessionStorage.setItem('tempRes', JSON.stringify(res.data));
    log('resDataNew', res.data);

    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      [userData] = res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.entrys;
      log(JSON.stringify(userData));
      return userData;
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0],
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  postPasswordChange = async (
    userName,
    userPassword,
    newUserPassword,
    newUserPasswordAgain,
    sessionId,
  ) => {
    // changing password on save in Changepassword
    log('start: postPasswordChange');
    // .replace(/\$/g, '$$$$'); // due to usage of replace
    let passwordMessage = JSON.stringify(passwordTemplate);
    const escapedPassword = userPassword.replace(/\$/g, '$$$$');
    const escapedNewPassword = newUserPassword.replace(/\$/g, '$$$$');
    const escapedNewPasswordAgain = newUserPasswordAgain.replace(/\$/g, '$$$$');
    passwordMessage = passwordMessage.replace(/\$USERNAME/, userName);
    passwordMessage = passwordMessage.replace(/\$PASSWORD/, escapedPassword);
    passwordMessage = passwordMessage.replace(/\$NEWPASSWORD/, escapedNewPassword);
    passwordMessage = passwordMessage.replace(
      /\$NEWPASSWORDAGAIN/,
      escapedNewPasswordAgain,
    );
    passwordMessage = passwordMessage.replace(/\$SESSIONID/, sessionId);
    // l
    log('passwordMessage: ', passwordMessage);
    const res = await axios
      .post(
        `${restPath}user/changepassword`,
        JSON.parse(passwordMessage),
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(error);
      });
    // ### Success ###
    // sessionStorage.clear();
    log('############ Success # Answer received:');
    // l
    log(JSON.stringify(res.data));
    log(
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] !== 'undefined',
    );
    log('############ after success');
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      // window.location.replace("./#/dashboard");
      return ['Das Kennwort wurde erfolgreich geändert.', 'success'];
    }
    log('############ else i.e. notification');
    log(
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0],
    );
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  postUserLogin = async (userName, userPassword, newPassword, newPasswordAgain) => {
    // log in user on save in Login
    log('start: postUserLogin');
    const loginMessage = { ...loginTemplate };
    // build message from template
    if (newPassword || newPasswordAgain) {
      loginMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.newPassword = newPassword;
      loginMessage.contents[
        'genesis.container.content.GenesisTMContent'
      ].transfermodel.newPasswordRepeat = newPasswordAgain;
    }
      loginMessage.contents[
          'genesis.container.content.GenesisTMContent'
          ].transfermodel.username = userName;
      loginMessage.contents[
          'genesis.container.content.GenesisTMContent'
          ].transfermodel.password = userPassword;
    // send request promise
    const res = await axios
      .post(
        `${restPath}userlogin/login`,
        loginMessage,
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(error);
        return ['Fehler bei der Anmeldung: Der Server ist nicht verfügbar.', 0, null];
      });
    // ### Success ###
    log(res);
    if (res[1] === 0) return res;
    sessionStorage.clear();
    log('############');
    log(JSON.stringify(res.data));
    log(
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.name,
    );
    log('############');
    if (
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.id
    ) {
      log('### ID erhalten');
      sessionStorage.setItem(
        'id',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.id,
      );
    }
    if (
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.id !== -1
    ) {
      sessionStorage.setItem(
        'id',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.id,
      );
      sessionStorage.setItem(
        'username',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.name,
      );
      sessionStorage.setItem(
        'firstName',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.firstName,
      );
      sessionStorage.setItem(
        'lastName',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.lastName,
      );
      sessionStorage.setItem(
        'zipcode',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.postID,
      );
      sessionStorage.setItem(
        'uuid',
        res.data.contents['genesis.container.content.GenesisTMContent'].uuid,
      );
      sessionStorage.setItem(
        'institution',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.company.companyName,
      );
      sessionStorage.setItem(
        'role',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.role,
      );
      sessionStorage.setItem(
        'group',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.group,
      );
      sessionStorage.setItem(
        'groupID',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.groupID,
      );

      window.location.replace('./');
      return ['', 0];
    }
    // finde Nachfrage in Notification
    const loginErrNum = res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].number;
    let loginErrText = res.data.contents['genesis.container.content.GenesisNotificationContent'].notifications[0].message;
    loginErrText = loginErrText.replace('Nutzername', 'Benutzername'); // same wording as on login form, requested by PO
    if (
      loginErrNum === 699
    ) {
      return [
        `${loginErrText} Ein gültiges Kennwort besteht aus mindestens 10 und maximal 20 Zeichen, wobei die Zeichen aus mindestens 3 der folgenden 4 Kategorien zu wählen sind: Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen. Keines der Zeichen \\ / : * " < > | darf enthalten sein.`,
        loginErrNum,
        null,
      ];
    } if (
      loginErrNum === 687 || loginErrNum === 690 || loginErrNum === 688 || loginErrNum === 10688
    ) {
      return [
        loginErrText,
        loginErrNum,
        null,
      ];
    } if (
      loginErrNum === 5104
    ) {
      const returnMessage = res;

      returnMessage.data.contents[
        'genesis.container.content.GenesisTMContent'
      ].menuRoot = null;
      returnMessage.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].stackTrace = [];
      returnMessage.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].handling = 'ACKNOWLEDGMENT'; // acknowledgement
      returnMessage.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].optionArray[0] = returnMessage.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].optionArray.pop();
      return [
        'Sie sind bereits am System angemeldet. Möchten Sie die aktuelle Session beenden und eine neue Session starten? Alle nicht gespeicherten Informationen gehen dabei verloren.',
        loginErrNum,
        returnMessage,
      ];
    }
    return [loginErrText, 0, null];
  }

  postSessionRenewal = async (positiveAnswer) => {
    // async postSessionRenewal(positiveAnswer) {
    // request new session on yes when already logged in in Login
    log('start: postSessionRenewal');
    log(JSON.stringify(positiveAnswer.data));
    // send request promise
    const res = await axios
      .post(
        `${restPath}userlogin/login`,
        positiveAnswer.data,
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(error);
      });
    // ### Success ###
    sessionStorage.clear();
    log('############');
    log(JSON.stringify(res));

    log(
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.name,
    );
    log('############');
    if (
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.id
    ) {
      log('### ID erhalten');
      sessionStorage.setItem(
        'id',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.id,
      );
    }
    if (
      res.data.contents['genesis.container.content.GenesisTMContent']
        .transfermodel.id !== -1
    ) {
      sessionStorage.setItem(
        'id',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.id,
      );
      sessionStorage.setItem(
        'username',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.name,
      );
      sessionStorage.setItem(
        'firstName',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.firstName,
      );
      sessionStorage.setItem(
        'lastName',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.lastName,
      );
      sessionStorage.setItem(
        'zipcode',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.postID,
      );
      sessionStorage.setItem(
        'uuid',
        res.data.contents['genesis.container.content.GenesisTMContent'].uuid,
      );
      sessionStorage.setItem(
        'institution',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.contact.organisationUnit,
      );
      sessionStorage.setItem(
        'role',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.role,
      );
      sessionStorage.setItem(
        'group',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.group,
      );
      sessionStorage.setItem(
        'groupID',
        res.data.contents['genesis.container.content.GenesisTMContent']
          .transfermodel.groupID,
      );
      window.location.replace('./');
    } else {
      return res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message;
    }
  }

  postUserLogout = async (logoutId) => {
    // postUserLogout(logoutId) {
    // logging out user from button in the application
    log('start: postUserLogout');
    log(logoutId);
    // build message from template
    let loginMessage = JSON.stringify(loginTemplate);
    loginMessage = loginMessage.replace(/\$USERNAME/, '');
    loginMessage = loginMessage.replace(/\$PASSWORD/, '');
    loginMessage = loginMessage.replace(
      /\$UUID/,
      sessionStorage.getItem('uuid'),
    );
    // send request promise
    axios
      .post(
        `${restPath}userlogin/logout`,
        JSON.parse(loginMessage),
        { headers: { 'Content-Type': 'application/json;charset=UTF-8' } },
      )
      .then(() => {
        sessionStorage.clear();
        window.location.replace(`${process.env.PUBLIC_URL}/login`);
      })
      .catch((error) => {
        log(error);
      });
  }

  postUserDelete = async (user) => {
    // async postUserDelete(user) {
    // deleting user initiated by X in Useradmin
    log('start: postUserDelete');
    // build message from template
    const delTemplate = JsonHelper.deepCopy(deleteTemplate); // for proper copy of object
    log('-' * 80);
    log(user);
    log(deleteTemplate);
    log('-' * 80);
    delTemplate.contents[
      'genesis.container.content.GenesisTMContent'
    ].transfermodel.entrys.push(user);
    // log(deleteTemplate);
    let deleteMessage = JSON.stringify(delTemplate);
    deleteMessage = deleteMessage.replace(
      /\$SESSIONID/,
      sessionStorage.getItem('uuid'),
    );
    log('THE MESSAGE');
    log(JSON.parse(deleteMessage));
    // send request promise
    const res = await axios
      .post(
        `${restPath}user/delete`,
        JSON.parse(deleteMessage),
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(user);
        log(error);
      });
    log('delete response');
    log(JSON.stringify(res.data));
    // sessionStorage.clear();
    // window.location.replace("./useradmin");
    if (
      typeof res.data.contents[
      'genesis.container.content.GenesisNotificationContent'
      ] === 'undefined'
    ) {
      log('success: no error in answer');
      return ['Nutzer erfolgreich gelöscht!', 'info'];
    } 
    
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    
    if (
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message.includes('Rolledback')
    ) {
      return ['Der Nutzer existiert nicht mehr.', 'info'];
    }
    return [
      res.data.contents[
        'genesis.container.content.GenesisNotificationContent'
      ].notifications[0].message,
      'error',
    ];
  }

  checkForLogout = async (resultMessage) => {
    // checkForLogout(resultMessage) {
    if (resultMessage === 'Fehler beim Auffinden der Session!') {
      window.location.replace(`${process.env.PUBLIC_URL}/login`);
    }
  }

  postMessage = async (jsonMessage, strUrl, strFunction, silent) => {
    // async postMessage(jsonMessage, strUrl, strFunction) {
    if (silent) {
      log('############ message sent but output set to silent');
    } else {
      log(`############ message sent for ${strFunction}:`);
      log(jsonMessage, restPath + strUrl, strFunction);
    }
    const res = await axios
      .post(
        restPath + strUrl,
        jsonMessage,
        { headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(error);
      });
    if (silent) {
      log('############ Answer received successfully but output set to silent');
    } else {
      log('############ Answer received successfully:', res);
    }
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    return res;
  }

  async getObject(strObj) {
    log('start: getObject');
    const newPath = `${restPath}functionblockcreatehelper/${strObj}`;
    const res = await axios
      .get(
        newPath,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`getObject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    log('end: getObject', res);
    return res;
  }

  /*
  getAverageobject = async () => {
    // async getCreatehelperCreatetextobject() {
    log('start: getAverageObject');
    const newPathUpload = `${restPath}functionblockcreatehelper/averageobject`;
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`getCreatehelperCreatetextobject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getCreatehelperCreatetextobject', res1);
    return res1;
  }

  getVZEobject = async () => {
    // async getVZEobject() {
    log('start: getVZEObject');
    const newPathUpload = `${restPath}functionblockcreatehelper/fulltimeequivalentobject`;
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`getCreatehelperCreatetextobject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getVZEobject', res1);
    return res1;
  }

  getMedianobject = async () => {
    // async getCreatehelperCreatetextobject() {
    log('start: getAverageObject');
    const newPathUpload = `${restPath}functionblockcreatehelper/medianobject`;
    const res1 = await axios
      .get(
        newPathUpload,
      )
      .catch((response) => {
        // handle error
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
        // return [`getCreatehelperCreatetextobject: ${errortext}`, 'error'];
        return ['Beim der Datenkommunikation ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.', 'error'];
      });
    log('end: getCreatehelperCreatetextobject', res1);
    return res1;
  }
  */

  postExportMessage = async (jsonMessage, strUrl, strFunction) => {
    // async postExportMessage(jsonMessage, strUrl, strFunction) {
    log(`############ message sent for ${strFunction}:`);
    log(jsonMessage, restPath + strUrl, strFunction);

    const res1 = await axios
      .post(
        restPath + strUrl,
        jsonMessage,
        { responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json' } },
      )
      .catch((error) => {
        log(error);
      });
    log('############ Answer received successfully:');
    this.checkForLogout(res1?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    log(res1);
    // log(JSON.stringify(res));
    log('############');
    return res1;
  }

  postJSonDebugQuery = async (strUrl,
    strQuery, qType, httpMethod, inDebugMessage, inResMessage) => {
    // send query to backend
    let debugMessage = inDebugMessage;
    let resMessage = inResMessage;
    log('start: postJSonDebugQuery');
    // build message from template
    debugMessage = JSON.stringify(debugTemplate);
    debugMessage = debugMessage.replace(/\$HTTPMETHOD/, httpMethod);
    debugMessage = debugMessage.replace(/\$URL/, strUrl);

    if (strQuery.length === 0 || qType === 'MySQL') {
      debugMessage = debugMessage.replace(/\$QUERY/, strQuery.replace(/"/g, "'"));
    } else {
      debugMessage = debugMessage.replace(/"\$QUERY"/, strQuery);
    }
    debugMessage = debugMessage.replace(/\$UUID/, sessionStorage.getItem('uuid'));

    log('debugMessage: ', debugMessage);
    // log(JSON.parse(debugMessage));

    if (qType === 'ElasticSearch') {
      // send request promise
      resMessage = await axios
        .post(
          `${restPath}debug/elasticsearch`,
          debugMessage,
          { headers: { 'Content-Type': 'application/json' } },
        )
        .catch((error) => {
          log(error);
          if (error.response) {
            return error.response;
          }
        });
    }
    if (qType === 'MySQL') {
      // send request promise
      resMessage = await axios
        .post(
          `${restPath}debug/mysql`,
          debugMessage,
          { headers: { 'Content-Type': 'application/json' } },
        )
        .catch((error) => {
          log(error);
          if (error.response) {
            return error.response;
          }
        });
    }
    log('############ Answer received successfully:');
    this.checkForLogout(resMessage?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    log(resMessage);
    // log(JSON.stringify(res));
    log('############');
    return resMessage;
  }

  writeTimeslices = async () => {
    const path = `${restPath}file/writeTimeslices?uuid=${sessionStorage.getItem('uuid')}`;
    const res = await axios
      .get(
        path,
      )
      .catch((response) => {
        log('This is the error to be returned: ', response);
        let errortext = response;
        if (response.response) errortext = response.response.data;
        log('This is the error to be returned: ', errortext);
      });
    this.checkForLogout(res?.data?.contents?.['genesis.container.content.GenesisNotificationContent']?.notifications?.[0]?.message);
    return res;
  }
}
